import { useState, useEffect, useCallback } from 'react';
import { Breakpoints } from '@bitcoin-portal/bitcoincom-pkg-theme';

const defaultBreakpoint: number = Breakpoints.md;

const isClientSide = (): boolean => typeof window !== 'undefined';

export const useBreakpoint = (
  breakpoint: number = defaultBreakpoint,
): boolean => {
  const [matches, setMatches] = useState<boolean>(
    isClientSide() ? window.innerWidth >= breakpoint : false,
  );

  const changeHandler = useCallback((event: MediaQueryListEvent): void => {
    if (event.matches) {
      setMatches(true);
    } else {
      setMatches(false);
    }
  }, []);

  useEffect(() => {
    const mediaQuery: string = `(min-width: ${breakpoint}px)`;
    const mediaQueryList: MediaQueryList | null = isClientSide()
      ? window.matchMedia(mediaQuery)
      : null;

    if (
      typeof mediaQueryList?.addEventListener === 'function' &&
      typeof mediaQueryList?.removeEventListener === 'function'
    ) {
      mediaQueryList.addEventListener('change', changeHandler);

      return (): void => {
        mediaQueryList.removeEventListener('change', changeHandler);
      };
    }

    return undefined;
  }, [breakpoint, changeHandler]);

  return matches;
};
